module.exports = __webpack_public_path__ + "static/media/chronic RelapsActive.c699b45b.svg";